import { createFileRoute } from "@tanstack/react-router";
import { CreatorsPage } from "../../../features/creators";

export const Route = createFileRoute("/$lang/_layout/creators")({
  component: CreatorsPage,
});
